export default "__VITE_ASSET__DK4P61VD__"